import { render, staticRenderFns } from "./delete-dialog.vue?vue&type=template&id=754402ef&"
import script from "./delete-dialog.vue?vue&type=script&lang=js&"
export * from "./delete-dialog.vue?vue&type=script&lang=js&"
import style0 from "./delete-dialog.vue?vue&type=style&index=0&id=754402ef&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports